import { useEffect, useState } from "react";
import { useTaskCreation } from "../../../hooks/useTaskCreation";
import {
  IOptionProps,
  IOptionsProps,
} from "../../../@types/reactSelect/IOption";
import axios from "../../../services/axios";
import { MessageBalloon } from "../../MessageBalloon/Index";
import { DropdownV2, CounterInputV2 } from "../../FormControlsV2";

interface BagReceiveProps {}

export const BagReceive: React.FC<BagReceiveProps> = () => {
  const [optionsProducts, setOptionsProducts] = useState<IOptionsProps>([]);
  const [classificationOption, setClassificationOption] =
    useState<IOptionProps | null>(null);
  const [productOption, setProductOption] = useState<IOptionProps | null>(null);
  const [quantity, setQuantity] = useState(0);

  const { payload, setPayload, setAllowTaskCreation, responsibleId, farmId } =
    useTaskCreation();

  useEffect(() => {
    axios.get("/products/all").then(({ data }) => {
      setOptionsProducts(
        data.map((el: any) => ({
          label: el.trade_name,
          value: el,
        })),
      );
    });
  }, []);

  useEffect(() => {
    setProductOption(null);
    setAllowTaskCreation(false);
  }, [classificationOption]);

  useEffect(() => {
    if (quantity == 0) {
      setAllowTaskCreation(false);
    } else {
      setValuesOnPayload();
    }
  }, [quantity]);

  function setValuesOnPayload() {
    const productSelected = productOption?.value as any;
    if (productSelected)
      setPayload({
        ...payload,
        changes: [
          {
            farm_id: farmId,
            assigned_user_id: responsibleId,
            product_id: productSelected?.id,
            quantity_ordered: quantity,
          },
        ],
      });
    setAllowTaskCreation(true);
  }

  const [mapTypes] = useState(new Map());
  const [optionTypes, setOptionTypes] = useState<IOptionsProps>([]);

  useEffect(() => {
    optionsProducts.map((el) =>
      mapTypes.set(
        (el?.value as any)?.classification,
        (el?.value as any)?.classification,
      ),
    );
    setOptionTypes(
      Array.from(mapTypes.keys()).map((el) => ({
        label: el,
        value: el,
      })),
    );
  }, [optionsProducts]);

  const classificationValue = classificationOption?.value as string | undefined;
  const productData = productOption?.value as any;

  return (
    <>
      <div className="balloon-container">
        <MessageBalloon
          text="Você deve criar uma tarefa por produto, você pode
          cadastrar mais produtos em “Gerenciar sistema”."
          pointed
        />
      </div>
      <DropdownV2
        name="bag-receive-classification"
        placeholder="Selecionar classificação do produto..."
        options={optionTypes}
        value={classificationOption}
        menuMount="overlay"
        onChange={(opt) => setClassificationOption(opt)}
      />

      {classificationValue && (
        <>
          <DropdownV2
            name="bag-receive-product"
            placeholder="Selecionar produto..."
            options={optionsProducts.filter(
              (el) => (el?.value as any)?.classification == classificationValue,
            )}
            value={productOption}
            menuMount="overlay"
            onChange={(opt) => setProductOption(opt)}
          />

          {productData && (
            <>
              <div>
                <div style={{ height: 10 }} />
                <span className="task-label">Resumo</span>

                <div className="body_resume">
                  <div className="formContainerProduct">
                    <label className="body_title">Nome comercial</label>
                    <label className="container_formResult">
                      {productData?.trade_name}
                    </label>
                  </div>
                  <div className="formContainerProduct">
                    <label className="body_title">Fabricante</label>
                    <label className="container_formResult">
                      {productData?.manufacturer}
                    </label>
                  </div>
                  <div className="formContainerProduct">
                    <label className="body_title">Consumo</label>
                    <label className="container_formResult">
                      {`${productData?.expected_consumption} g/kg de PV`}
                    </label>
                  </div>
                  <div className="formContainerProduct">
                    <label className="body_title">Frequência</label>
                    <label className="container_formResult last">
                      {`${productData?.supply_frequency} x por semana`}
                    </label>
                  </div>
                </div>
              </div>

              <div className="balloon-container">
                <MessageBalloon
                  text="Qual a quantidade em quilo do produto?"
                  pointed
                />
              </div>

              <CounterInputV2
                name="bag-receive-quantity"
                suffix="Kg"
                value={quantity}
                min={0}
                max={99999999}
                onChange={(v) => setQuantity(v)}
              />
            </>
          )}
        </>
      )}
    </>
  );
};
